import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Toast from '../Toast/Toast';
import InputWrapper from '../FormInputFields/InputWrapper/InputWrapper';
import './inputWithCopyToClipboard.styles.less';

class CopyToClipboard extends Component {
  state = {
    toastIsOpen: false,
    toastMessageKey: ''
  };

  copyValue = () => {
    const el = document.createElement('input');
    el.value = this.props.value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    this.openToast('customer.profileData.copiedToClipboard');
  };

  openToast = (messageKey) => {
    this.setState({
      toastIsOpen: true,
      toastMessageKey: messageKey
    });
  };

  resetToast = () => {
    this.setState({
      toastIsOpen: false,
      toastMessageKey: ''
    });
  };

  componentDidMount() {
    if (this.props.hidden) {
      this.copyValue();
    }
  }

  render() {
    const {
      intl,
      className,
      propertyName,
      onChange,
      value,
      defValue,
      error,
      onBlur,
      hidden,
      showIconOnly
    } = this.props;
    const { formatMessage } = intl;
    const resetButton =
      defValue && defValue !== value ? (
        <button
          className={'link-btn-reset-to-def'}
          onClick={() => onChange(defValue, propertyName)}
        >
          {formatMessage({ id: 'general.btn.reset' })}
        </button>
      ) : null;

    return (
      <React.Fragment>
        { hidden ? null :
        (<div
          className={`${className || ''} input-copy-to-clipboard`}
          data-automation-id={`automation-${this.props.labelKey}`}
          role="presentation">

           {showIconOnly ? null : (  
            <>
              <div className="input-copy-to-clipboard-label" onClick={this.copyValue}>
                {formatMessage({ id: this.props.labelKey })}
              </div>

              <InputWrapper
                onChange={(e) => onChange(e.target.defaultValue, propertyName)}
                onBlur={onBlur}
                value={this.props.value}
                disabled={this.props.disabled || false}
                error={error}/>
            </>
              )}

          <i
            role="button"
            onClick={this.copyValue}
            className="icon como-ic-duplicate"
          />

          {resetButton}
        </div>) }

        <Toast
          intl={intl}
          className="copy-clipboard-toast"
          isOpen={this.state.toastIsOpen}
          messageKey={this.state.toastMessageKey}
          onClose={this.resetToast}
        />
      </React.Fragment>
    );
  }
}

CopyToClipboard.propTypes = {
  propertyName: PropTypes.string,
  className: PropTypes.string,
  intl: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  defValue: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  showIconOnly: PropTypes.bool
};

export default injectIntl(CopyToClipboard);
